import React from 'react';
import ReactDOM from 'react-dom/client';

import packageJson from '../package.json';

import { App } from './app';

import './styles/fonts.css';
import './styles/reset.css';

const root = document.getElementById('root');

if (root) {
  root.setAttribute('data-app-version', packageJson.version);

  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <App data-app-version={packageJson.version} />
    </React.StrictMode>,
  );
}
